import styled from 'styled-components';
import { Nav, NavLink as NavLinkBase, Popover } from 'reactstrap';
import { TextField } from 'shared/components/form/Inputs';

import BackgroundBox from 'shared/components/BackgroundBox';
import { Modal } from 'shared/components/modal/Modals';
import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

export const NotificationDetailWrapper = styled.div`
  height: ${({ isCurrentNotification }) => (isCurrentNotification ? 'auto' : '818px')};
  @media ${device.sm} {
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
  }
  @media ${device.md} {
    .collapse-client-container {
      margin-left: 9px;
      margin-bottom: 10px;
    }
  }
  @media ${device.lg} {
    .collapse-client-container {
      margin-left: 0;
      margin-bottom: 0;
    }
  }
  @media ${device.xl} {
    .collapse-client-container {
      margin-left: 0;
      margin-bottom: 0;
    }
  }
  .collapse-client-container {
    height: 48px;
    width: 48px;
    border-radius: 2px;
    background-color: ${colors.white};
    box-shadow: 0 0 15px 0 ${colors.mercury};
    display: flex;
    justify-content: center;
  }
`;

export const BackgroundBoxNotificationReview = styled(BackgroundBox)`
  margin-bottom: 0;
  padding: 0 15px;
  @media ${device.sm} {
    width: 98%;
  }
  @media ${device.md} {
    width: 77%;
  }
  @media ${device.lg} {
    width: 45%;
  }
  @media ${device.xl} {
    width: 47%;
  }
  .link-download {
    &:hover,
    &:active {
      color: ${({ secondaryColor }) => secondaryColor} !important;
      cursor: pointer;
    }
  }
  .description-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .description-to-notify-link {
      border: solid 1px ${colors.zambezi};
      padding: 0px 8px;
      border-radius: 2px;
      background-color: #ffffff;
      box-shadow: 0 1px 1px 0 #d6d8d9;
      &:hover {
        cursor: pointer;
      }
      span {
        color: ${colors.zambezi};
        font-family: MTTMilano;
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 0;
      }
      .icon {
        width: 20px;
        height: 20px;
        padding-right: 5px;
      }
    }
  }
  .description-notify-title {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 16px;
  }
  .description-notify-text {
    color: ${colors.black};
    font-family: ${fonts.default};
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 16px;
  }
  .communication-detail-not-found {
    color: ${colors.suvaGrey};
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    position: relative;
    top: 11%;
    height: 92%;
    svg {
      height: 71.61px;
      width: 62.6px;
    }
    p {
      width: 18%;
      text-align: center;
      color: ${colors.suvaGrey};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 16px;
      margin: 2px 0 0 0;
    }
  }
  .container-participants {
    width: 50%;
    display: flex;
    justify-content: end;
    cursor: pointer;
    .button-icon svg {
      height: 22.05px;
      width: 22.25px;
    }
    .number-participants-container {
      height: 17.03px;
      width: 17px;
      background-color: ${colors.pattens};
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      left: -8px;
      span {
        color: ${colors.zambezi};
        font-family: ${fonts.default};
        font-size: 11px;
        font-weight: 500;
        position: relative;
        top: 2px;
      }
    }
    &:hover {
      button:active {
        background-color: ${colors.transparent} !important;
      }
      .button-icon svg {
        fill: ${colors.black};
      }
      .number-participants-container {
        background-color: ${colors.transparent};
        box-sizing: border-box;
        border: 1px solid ${colors.black};
      }
    }
  }
  .w-nav-container {
    width: 60%;
  }
  .search-comment-container {
    width: 40%;
    position: relative;
    top: 9px;
  }
`;

export const PopoverParticipants = styled(Popover)`
  .popover {
    width: auto;
    border-radius: 4px;
    background-color: ${colors.white};
    box-shadow: 2px 2px 4px 1px rgba(133, 133, 133, 0.5);
    min-height: auto;
    max-height: 350px;
    height: auto;
    overflow: auto;
    .popover-body {
      .participant-list {
        display: flex;
        align-items: center;
        height: 39px;
        padding: 15px;
        &:hover {
          cursor: pointer;
          background-color: ${colors.whiteSmoke};
        }
        .participant-circle {
          height: 29px;
          width: 35px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          .participant-circle-text {
            color: ${colors.white};
            font-family: ${fonts.default};
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 21px;
            position: relative;
            top: 2px;
          }
        }
        .participant-full-text {
          font-family: ${fonts.roboto};
          font-size: 14px;
          letter-spacing: 0;
          line-height: 18px;
          padding-left: 5px;
        }
      }
      padding: 0;
      width: 186px;
    }
  }
  .popover .arrow::before,
  .popover .arrow::after {
    border-style: none;
  }
  .label-icon-sort {
    height: 25px;
  }
`;

export const FullName = styled.span`
  color: ${({ active }) => (active ? `${colors.black}` : `${colors.pattens}`)};
`;

export const ParticipantCircle = styled.div`
  color: ${({ active }) => (active ? `${colors.black}` : `${colors.pattens}`)};
  background-color: ${({ mainColor, active }) => (active ? `${mainColor}` : `${colors.pattens}`)};
`;

export const ContainerBtnFileUploaders = styled.div`
  width: 166px;
  margin-left: 9px;
  margin-top: 15px;
`;

export const H3 = styled.h3`
  color: ${colors.black} !important;
  font-family: ${fonts.default} !important;
  font-size: ${fontSizes.lg} !important;
  font-weight: bold !important;
  letter-spacing: 0 !important;
  line-height: 21px !important;
  margin-bottom: 35px;
`;

export const ClientPanelBackground = styled(BackgroundBox)`
  padding: 0;
  padding-bottom: 25px;
  font-family: ${fonts.medium};
  font-size: ${fontSizes.sm}px;
  height: auto;
  @media ${device.sm} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.md} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.lg} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 0;
  }
  @media ${device.xl} {
    flex: 0 0 21%;
    margin-left: 0;
    margin-bottom: 0;
  }
`;
export const NotifyPanelBackground = styled(BackgroundBox)`
  padding: 16px;
  padding-bottom: 25px;
  font-family: ${fonts.medium};
  font-size: ${fontSizes.sm}px;
  display: grid;
  grid-template-rows: 30px 60px auto;
  @media ${device.sm} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.md} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  @media ${device.lg} {
    flex: 0 0 22%;
    margin-left: 10px;
    margin-bottom: 0;
  }
  @media ${device.xl} {
    flex: 0 0 23%;
    margin-left: 0;
    margin-bottom: 0;
  }
  .notification-name-container {
    display: flex;
    width: 100%;
    .notification-name {
      color: ${colors.black};
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 300px;
      flex: 1 1 auto;
    }
  }

  .notification-date-time {
    color: ${colors.romanSilver};
    font-family: ${fonts.default};
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
  }
  .chat-notifications-not-found {
    color: ${colors.suvaGrey};
    font-family: ${fonts.default};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 16px;
    svg {
      height: 71.61px;
      width: 62.6px;
    }
    p {
      width: 45%;
      text-align: center;
      color: ${colors.suvaGrey};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 16px;
      margin: 5px 0 0 0;
    }
  }
  .panel-title-container {
    height: 42px;
  }
`;

export const CollapseClientRight = styled.div`
  border-radius: 18px;
  background-color: ${colors.gullGrey};
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 27px;
  width: 27px;
  svg {
    fill: ${colors.white};
    height: 16px;
    width: 27px;
  }
`;

export const NavHome = styled(Nav)`
  border-bottom: 1px solid ${colors.pattens};
  margin-top: 11px;
  width: 100%;
  li {
    width: 50%;
  }
  @media ${device.sm} {
    display: none;
  }
  @media ${device.md} {
    display: block;
  }
  @media ${device.lg} {
    display: flex;
  }
  @media ${device.xl} {
    display: flex;
  }
`;

export const NavLink = styled(NavLinkBase)`
  border: none !important;
  border-bottom: ${({ selected }) => (selected ? '2px' : '1px')} solid ${({ color }) => color} !important;
  color: ${colors.black};
  cursor: pointer;
  font-family: ${fonts.default};
  font-size: ${fontSizes.xxs}px;
  font-weight: ${({ selected }) => (selected ? 'bold' : '500')};
  letter-spacing: 0;
  line-height: 12px;
  text-align: center;
  text-transform: uppercase;
`;

export const SearchComment = styled(TextField)`
  width: 100% !important;
  margin: unset;
  input {
    color: ${colors.gullGrey};
    font-size: ${fontSizes.sm}px;
    letter-spacing: 0;
    line-height: 18px;
  }
`;

export const SelectAdvisorModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding: 0.6rem;
  }
`;

export const CommunicationClientsModal = styled(Modal)`
  top: 15%;
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
  .row-title {
    padding-bottom: 17px;
    width: 100%;
    margin-left: 1px;
    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
      text-align: center;
    }
  }
  .general-customizer__page-header-otions {
    margin: 0;
  }
  .list-unstyled {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  @media ${device.sm} {
    .list-unstyled {
      grid-template-columns: 1fr;
    }
  }
  .group-options__option-list {
    max-height: 500px;
    overflow: auto;
  }
`;
